/* eslint-disable no-restricted-imports */
import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import { ACCOUNT_TABS } from '@/components/content/Account/parts/Tabs';
import {
	AccountSummaryMonederoContainerSx,
	AccountSummaryMonederoTextSx,
	AccountSummaryMonederoAmountContainerSx,
	AccountSummaryMonederoAmountSx,
} from '@/components/content/Account/styles/summary';

interface AccountSummaryMonederoProps {
	balance: number;
	onSelectedTab: (tab: ACCOUNT_TABS) => void;
}

export const AccountSummaryMonedero: React.FC<AccountSummaryMonederoProps> = ({
	balance,
	onSelectedTab,
}) => {
	return (
		<Box sx={AccountSummaryMonederoContainerSx}>
			<Box>
				<Typography sx={AccountSummaryMonederoTextSx}>{'TU MONEDERO ELECTRÓNICO'}</Typography>
			</Box>
			<Box sx={AccountSummaryMonederoAmountContainerSx}>
				<Typography sx={AccountSummaryMonederoAmountSx}>
					{new Intl.NumberFormat('es-MX', {
						style: 'currency',
						currency: 'MXN',
					}).format(balance)}
				</Typography>
			</Box>
		</Box>
	);
};
